<div class="main">
    <div class="dx-field-title" translate>localAgents.pageTitle</div>
    <dx-data-grid #localAgents
                  height="calc(100vh - 150px)"
                  hoverStateEnabled="true"
                  keyExpr="id"
                  [columnAutoWidth]="true"
                  [dataSource]="dataSource"
                  [errorRowEnabled]="false"
                  [focusedRowEnabled]="true"
                  [wordWrapEnabled]="true"
                  (onContextMenuPreparing)="onContextMenuPreparing($event)"
                  (onRowDblClick)="displayLocalAgent($event)"
                  (onRowPrepared)="onRowPrepared($event)">
        <dxo-search-panel [visible]="true" [width]="250" [placeholder]="'_commons.search' | translate"></dxo-search-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-scrolling showScrollbar="always"></dxo-scrolling>
        <dxo-summary>
            <dxi-total-item column="displayName" [displayFormat]="'localAgents.lblLocalAgentsCount' | translate" summaryType="count"></dxi-total-item>
        </dxo-summary>
        <dxo-toolbar>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="add" [text]="'_commons.add' | translate" (onClick)="displayNewPopup()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item location="after">
                <div *dxTemplate>
                    <dx-button icon="refresh" [text]="'_commons.refresh' | translate" (onClick)="loadDataSource()"></dx-button>
                </div>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>

        <!-- Standard columns -->
        <dxi-column dataField="displayName" [caption]="'localAgents.lblName' | translate"></dxi-column>
        <dxi-column dataField="currentStatus" [caption]="'localAgents.lblStatus' | translate" [calculateCellValue]="getLocalAgentStatus" [width]="150"></dxi-column>
        <dxi-column dataField="serverName" [caption]="'localAgents.lblServerName' | translate"></dxi-column>
        <dxi-column dataField="serviceAccount" [caption]="'localAgents.lblServiceAccount' | translate"></dxi-column>
        <dxi-column dataField="authenticationMode" [caption]="'localAgents.lblAuthenticationMode' | translate" [calculateCellValue]="getLocalAgentAuthenticationMode" [width]="200"></dxi-column>
        <dxi-column dataField="lastContactOn" [caption]="'localAgents.lblLastContactOn' | translate" [calculateCellValue]="displayLastContactDate" [width]="200"></dxi-column>
        <dxi-column dataField="countFlows" [caption]="'localAgents.lblTransfers' | translate" [width]="150"></dxi-column>
        <dxi-column dataField="isDisabled" [caption]="'localAgents.lblIsDisabled' | translate" [width]="150"></dxi-column>
    </dx-data-grid>
</div>

<!-- Display popup -->
<dx-popup [title]="'localAgents.popupTitle' | translate" [(visible)]="isDisplayPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view id="scrollview" direction="vertical">
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblIsDisabled</div>
                <div class="dx-field-value">
                    <dx-switch [readOnly]="true" [(value)]="displayedLocalAgent.isDisabled"></dx-switch>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>_commons.id</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [(value)]="displayedLocalAgent.id"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblName</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [(value)]="displayedLocalAgent.name"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblType</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayAgentType(displayedLocalAgent)"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblAuthenticationMode</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayAgentAuthenticationMode(displayedLocalAgent)"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblEntraId</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayedLocalAgent.entraId"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblPublicIpAddresses</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [(value)]="displayedLocalAgent.publicIpAddresses"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblStatus</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="getLocalAgentStatus(displayedLocalAgent)"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblAssemblyVersion</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayedLocalAgent.currentAssemblyVersion"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblAssemblyFileVersion</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayedLocalAgent.currentAssemblyFileVersion"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblAssemblyInformationalVersion</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayedLocalAgent.currentAssemblyInformationalVersion"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblServerName</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayedLocalAgent.serverName"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblServiceAccount</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayedLocalAgent.serviceAccount"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblVersionsUpdatedOn</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayDate(displayedLocalAgent.versionsUpdatedOn)"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblStatusUpdatedOn</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayDate(displayedLocalAgent.statusUpdatedOn)"></dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label" translate>localAgents.lblLastContactOn</div>
                <div class="dx-field-value">
                    <dx-text-box [readOnly]="true" [value]="displayDate(displayedLocalAgent.lastContactOn)"></dx-text-box>
                </div>
            </div>
            <div class="flex bottom-buttons">
                <dx-button class="close" [text]="'_commons.close' | translate" (onClick)="this.isDisplayPopupVisible = false"></dx-button>
            </div>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- New & Edit popup -->
<dx-popup [title]="'localAgents.popupTitle' | translate" [width]="650" [height]="500" [(visible)]="isEditPopupVisible">
    <div *dxTemplate="let data of 'content'">
        <dx-scroll-view *ngIf="isEditPopupVisible">
            <dx-validation-group #localAgentValidation>
                <div class="dx-field">
                    <div class="dx-field-label" translate>
                        localAgents.lblName<span class="dx-field-item-required-mark">*</span>
                    </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedLocalAgent.name">
                            <dx-validator>
                                <dxi-validation-rule type="required" [message]="'localAgents.msgLocalAgentNameRequired' | translate"></dxi-validation-rule>
                                <dxi-validation-rule type="stringLength" [max]="100" message="'_validators.maxLength100' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>
                        localAgents.lblType<span class="dx-field-item-required-mark">*</span>
                    </div>
                    <div class="dx-field-value">
                        <app-agent-type-picker [(selectedItem)]="selectedLocalAgent.agentType"></app-agent-type-picker>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>
                        localAgents.lblAuthenticationMode<span class="dx-field-item-required-mark">*</span>
                    </div>
                    <div class="dx-field-value">
                        <app-agent-authentication-mode-picker [(selectedItem)]="selectedLocalAgent.authenticationMode"></app-agent-authentication-mode-picker>
                    </div>
                </div>
                <div class="dx-field" *ngIf="selectedLocalAgent.authenticationMode === 1">
                    <div class="dx-field-label" translate>
                        localAgents.lblEntraId<span class="dx-field-item-required-mark">*</span>
                    </div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="selectedLocalAgent.entraId">
                            <dx-validator>
                                <dxi-validation-rule *ngIf="selectedLocalAgent.authenticationMode === 1" type="required" [message]="'localAgents.msgEntraIdRequired' | translate"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class="dx-field">
                    <div class="dx-field-label" translate>localAgents.lblPublicIpAddresses</div>
                    <div class="dx-field-value">
                        <dx-text-box [showClearButton]="true" [(value)]="selectedLocalAgent.publicIpAddresses"></dx-text-box>
                    </div>
                </div>
                <div class="flex bottom-buttons">
                    <dx-button class="add" [text]="'_commons.add' | translate" (onClick)="createLocalAgent()"
                               [visible]="isNew"></dx-button>
                    <dx-button class="save" [text]="'_commons.save' | translate" (onClick)="updateLocalAgent()"
                               [visible]="!isNew"></dx-button>
                    <dx-button class="cancel" [text]="'_commons.cancel' | translate" (onClick)="this.isEditPopupVisible = false"></dx-button>
                </div>
            </dx-validation-group>
        </dx-scroll-view>
    </div>
</dx-popup>

<!-- Check Connection popup -->
<app-local-agent-check-connection #checkConnectionPopup></app-local-agent-check-connection>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
